import React, { FC, useCallback, useMemo, useState } from 'react';
import { useParams } from 'react-router';

import TabPanel from 'devextreme-react/tab-panel';

import { useAuth } from 'context/auth';
import { useDataSource } from 'utils/create-data-souce-instance';

import { useGetRequestQuery } from 'bus/request';

import { TaskCreateScreen } from './TaskCreateScreen';
import { TaskDetailScreen } from './TaskDetailScreen';
import { RequestHistory, WorkList } from './View';

const itemTitleRender = (tab: { name: string; index: number }) => {
  return <span>{tab.name}</span>;
};

const DetailTabs: FC = () => {
  const { id } = useParams<{ id: string }>();
  const { refetch } = useGetRequestQuery({ id }, { skip: Boolean(!id) });

  const storeContragent = useDataSource('/v1/Contractor', 'id', {
    pageSize: 20,
    paginate: true,
    defaultFilter: ['isOwner', '=', true],
  });

  const storeCustomer = useDataSource('/v1/Contractor', 'id', {
    pageSize: 20,
    paginate: true,
    defaultFilter: ['isOwner', '=', false],
  });

  const storeContractorLegal = useDataSource('/v1/ContractorLegal', 'id', {
    pageSize: 20,
    paginate: true,
  });

  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const { getClaims }: any = useAuth();

  const canVisibleHistory = getClaims(['CanLookRequestHistory']);

  const tabs = useMemo(
    () => [
      {
        name: 'Основная информация',
        index: 0,
      },
      {
        name: 'Список работ',
        index: 1,
      },
      {
        name: 'История',
        index: 2,
        visible: canVisibleHistory,
      },
    ],
    [canVisibleHistory],
  );

  const handleOptionChanged = useCallback(
    (e: any) => {
      if (e.name === 'selectedIndex') {
        if (e.value === 0) {
          refetch();
        }
        setSelectedIndex(e.value);
      }
    },
    [refetch],
  );

  if (!id)
    return (
      <TaskCreateScreen
        storeContragent={storeContragent}
        storeCustomer={storeCustomer}
        storeContractorLegal={storeContractorLegal}
      />
    );

  return (
    <div>
      <TabPanel
        height="auto"
        dataSource={tabs}
        selectedIndex={selectedIndex}
        onOptionChanged={handleOptionChanged}
        itemTitleRender={itemTitleRender}
        animationEnabled={false}
      />

      {selectedIndex === 0 && (
        <div className="tab-content">
          <TaskDetailScreen
            storeContragent={storeContragent}
            storeCustomer={storeCustomer}
            storeContractorLegal={storeContractorLegal}
          />
        </div>
      )}
      {selectedIndex === 1 && (
        <div className="tab-content">
          <WorkList />
        </div>
      )}
      {selectedIndex === 2 && (
        <div className="tab-content">
          <RequestHistory />
        </div>
      )}
    </div>
  );
};

export default DetailTabs;
